module.exports = __webpack_public_path__ + "static/img/quick-scan-right.4e17a193.jpg";